import React from 'react'
import { Container } from '@mui/material'
import AdminAccounts from './AdminAccounts/AdminAccounts'
import { AdminScreen, Navigation } from '@professocial/professocialTypes/types/commonTypes'
import { Route, Switch } from 'react-router-dom'
import { useRouteMatch } from 'react-router'
import UnlinkedPagesTable from '@professocial/professocialAccounts/src/shared/components/AccountManagement/UnlinkedPagesTable'

export const navigationAdminListData: Navigation[] = [
  {
    value: 'accounts',
    label: 'accounts',
    key: 'accounts',
    changeTo: AdminScreen.accounts,
  },
  {
    value: 'unlinkedPages',
    label: 'unlinkedPages',
    key: 'unlinkedPages',
    changeTo: AdminScreen.unlinkedPages,
  },
]

const AdminApp: React.FC = () => {
  const { path } = useRouteMatch()
  return (
    <>
      <Switch>
        <Route path={`${path}/accounts`}>
          <Container maxWidth='xl'>
            <AdminAccounts />
          </Container>
        </Route>
        <Route path={`${path}/unlinkedPages`}>
          <Container maxWidth='xl'>
            <UnlinkedPagesTable />
          </Container>
        </Route>
      </Switch>
    </>
  )
}
export default AdminApp
